import React from 'react'
import Try from '../pages/Try'
import Navbar from '../Components/NavBar'
import Layout from '../Components/Layout'
import MyProjects from '../Components/MyProjects'
import '../Responsive.css'

const Projects = () => {
  return (
    <Layout title="Sarvadnya || Projects">
      <div className='relative min-h-screen'>
        <Try />
        <Navbar />
        <MyProjects />
      </div>
    </Layout>
  )
}

export default Projects;
